const delay = (dur: number) =>
  new Promise((resolve) => setTimeout(resolve, dur))

export default delay
